import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Parallax } from "react-parallax";
import { Helmet } from 'react-helmet-async';
import Navbar from '../layout/Navbar';
import Preloader from '../layout/preloader';
import BannersListar from '../section-pages/banners-listar';
import UltimasNoticias from '../section-pages/ultimas-noticias';
import Eventos from '../section-pages/eventos-listar';
import Footer from '../section-pages/footer';
import ScrollToTopBtn from '../layout/ScrollToTop';
import { createGlobalStyle } from 'styled-components';
import ApiSite from '../services/siteService';

const image1 ="./img/background/3.webp";

const GlobalStyles = createGlobalStyle`
  .navbar-brand .imginit{
      display: block ;
    }
  .navbar-brand .imgsaly{
    display: none !important;
  }
  .academia{
    background-image: url('./img/background/Angle-Gradients-2-Blue.png') !important;
    background-size: cover; 
    background-position: top; 
    background-repeat: no-repeat; 
    padding: 20px 0;
    margin: 20px 0;
    display: flex; 
    justify-content: center; 
    align-items: center; 
  }
`;

export default function Home() {
  const [isLoading, setIsLoading] = useState(true);
  const [banners, setBanners] = useState([]);
  const [noticias, setNoticias] = useState([]);
  const [eventos, setEventos] = useState([]);
      
  useEffect(() => {
      if (typeof window !== 'undefined') {
          const loader = document.getElementById('mainpreloader');
          if (loader)
          setTimeout(() => {
            loader.classList.add("fadeOut");
            loader.style.display = 'none';
          }, 600)
      }
    }, []);

    useEffect(() => {
      const fetchHome = async () => {
        try {
          const response = await ApiSite.index();
          setBanners(response.data.banners);
          setNoticias(response.data.noticias);
          setEventos(response.data.eventos);
        } catch (error) {
          console.error('Erro ao buscar dados:', error);
        } finally {
          setIsLoading(false);
        }
      };
    
      fetchHome();
    }, []);
  return (
    <>

    {/* HEAD */}
    <Helmet>
      <link rel="icon" href="./img/icon.png" />
      <title>Fetron - Federação de Taekwondô de Rondônia</title>
    </Helmet>

    <GlobalStyles/>

    {/* LOADER */}
    <div id='mainpreloader'>
      <Preloader/>
    </div>

    {/* MENU */}
    <div className="home dark-scheme">
      <header id="header-wrap">
         <Navbar />
      </header>

      {banners && 
        <Parallax className="" bgImage={image1} strength={5}>
          <section className="no-bg">
            <BannersListar banners={banners}/>
            <div className="row eventos-ranking">
              <div className="col-lg-6 bt-evento">
                <Link className="btn-evento mb-sm-30 mb-5" to="/eventos">EVENTOS</Link>
              </div>
              <div className="col-lg-6 bt-ranking">
                <Link className="btn-ranking mb-sm-30 mb-5" to="/ranking">RANKING</Link>
              </div>
            </div>
          </section>
        </Parallax>
      }

      <section className="no-bg">
        <div className="section-vinculados-filiados">
          <div className="section-vinculados-filiados-desktop">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <center>
                  <h3 className="mb-0 titulo">FILIADOS/VINCULADOS</h3>
                  <center><strong>Encontre uma academia perto de você</strong></center>
                  <Link className="btn-vf mb-sm-30 mt-2" to="/academias">Ver Todas</Link>
                </center>
              </div>        
            </div>
          </div>

          <div className="section-vinculados-filiados-mobile">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <center>
                  <h6 className="mb-0 titulo">FILIADOS/VINCULADOS</h6>
                  <Link className="btn-vfm" to="/academias">Ver Todas</Link>
                </center>
              </div>        
            </div>
          </div>
        </div>
      </section>   

      {noticias &&
        <Parallax className="" bgImage={image1} strength={300}>  
          <div className="de-gradient-edge-top"></div>
          <div className="de-gradient-edge-bottom"></div>
          <section className="no-bg">
            <UltimasNoticias noticias={noticias}/>
          </section>
        </Parallax>
      }

      {eventos &&
        <section className="no-bottom">
          <Eventos eventos={eventos} ano={new Date().getFullYear()}/>
        </section>
      }   

      <Footer/>

    </div>
    <ScrollToTopBtn />
    </>
  )
}
